
// function ForSalePriceAndTemplate({
//   initialBestOffer,
//   initialPrice,
//   initialShippingTemplate,
//   onPriceAndShippingChange,
// }) {
//   const { userId } = useContext(AuthContext);
//   const [price, setPrice] = useState(initialPrice);
//   const [shippingTemplateId, setShippingTemplateId] = useState(
//     initialShippingTemplate
//   );
//   const [selectedPreference, setSelectedPreference] = useState(null);
//   const [minorCardShipping, setMinorCardShipping] = useState("");
//   const [mediumCardShipping, setMediumCardShipping] = useState("");
//   const [bigCardShipping, setBigCardShipping] = useState("");
//   const [otherDetails, setOtherDetails] = useState("");
//   const [AdditionnalCard,setAdditionnalCard] = useState('');
//   const [ShippingToCanada,setShippingToCanada] = useState('');
//   const [ShippingToUs,setShippingToUs] = useState('');
//   const [ShippingCostToUs,setShippingCostToUs] = useState('');
//   const [acceptOffer, setAcceptOffer] = useState(initialBestOffer);
//   const [shippingCost, setShipping] = useState("");
//   const [shippingPreferences, setShippingPreferences] = useState([]);
//   const [showOtherDetails, setShowOtherDetails] = useState(false); // To track the visibility of "Other Details" input.
 
// const [editing, setEditing] = useState(false); // Track editing mode
// const [editedTitle, setEditedTitle] = useState(''); // Track edited title
// const [editedMinorCardShipping, setEditedMinorCardShipping] = useState('');
// const [editedMediumCardShipping, setEditedMediumCardShipping] = useState('');
// const [editedBigCardShipping, setEditedBigCardShipping] = useState('');
// const [editedOtherDetails, setEditedOtherDetails] = useState('');
// const [editedAdditionnalCard,setEditedAdditionnalCard] = useState('');
// const [editedShippingToCanada,setEditedShippingToCanada]  = useState('');
// const [editedShippingToUs,setEditedShippingToUs]  = useState('');
// const [editedShippingCostToUs,setEditedShippingCostToUs] = useState('');


// function getPreferences() {
//   fetch(`${process.env.REACT_APP_API_BASE}/api/get/shipping-preferences/${userId}`)
//     .then((response) => response.json())
//     .then((data) => {
//       if (data) {
//         const preference = {
//           label: data.TemplateTitle,
//           value: data.ShippingPreferenceId,
//           minorCardShipping: data.MinorCardShipping,
//           mediumCardShipping: data.MediumCardShipping,
//           bigCardShipping: data.BigCardShipping,
//           otherDetails: data.OtherDetails,
//           acceptOffer: data.acceptOffer,
//           AdditionnalCard: data.AdditionnalCard,
//           ShippingToCanada: data.ShippingToCanada,
//           ShippingToUs: data.ShippingToUs,
//           ShippingCostToUs: data.ShippingCostToUs,
//         };
//         console.log('preference', preference);
//         setShippingPreferences([preference]); // Store preference as an array if expected in the UI
//         setSelectedPreference(preference);    // Optionally set selected preference directly
//       }
//     })
//     .catch((error) => {
//       console.log("Error:", error);
//     });
// }


//   useEffect(() => {
//     getPreferences();
//     // Fetch fresh card data when the component mounts
//   }, []);

//   useEffect(() => {
//     // Initialize selectedPreference to the first item when shippingPreferences updates.
//     if (shippingPreferences.length > 0) {
//       console.log('shippingPreferences',shippingPreferences)
//       setSelectedPreference(shippingPreferences);
//       setOtherDetails(shippingPreferences.otherDetails);
//     }
//   }, [shippingPreferences]);

//   useEffect(() => {
//     // Update the locked input fields when the selected preference changes
//     console.log("jessaie");
//     console.log("selectedpref ", selectedPreference);
//     if (selectedPreference) {
//       console.log("jaireussi");
//       setMinorCardShipping(selectedPreference.minorCardShipping);
//       setMediumCardShipping(selectedPreference.mediumCardShipping);
//       setBigCardShipping(selectedPreference.bigCardShipping);
//       setAdditionnalCard(selectedPreference.AdditionnalCard);
//       setShippingToCanada(selectedPreference.ShippingToCanada);
//       setShippingToUs(selectedPreference.ShippingToUs);
//       setShippingCostToUs(selectedPreference.ShippingCostToUs);
//     }
//   }, [selectedPreference]);

//   useEffect(() => {
//     // Update the locked input fields when the selected preference changes
//      console.log('price',price,'mediumCardShipping',selectedPreference.mediumCardShipping,'minorCardShipping',minorCardShipping,'bigCardShipping',bigCardShipping)
//     if (!isNaN(price)) {
//       let shipping = 0;
//       if (price <= 20) {
//         shipping = selectedPreference.minorCardShipping;
//       } else if (price > 20 && price <= 75) {
//         shipping = selectedPreference.mediumCardShipping;
//       } else if (price > 75) {
//         shipping = selectedPreference.bigCardShipping;
//       }
//       console.log('shipping',shipping)
//       setShipping(shipping);
//     } else {
//       // Handle invalid input or provide user feedback
//       console.log("Error, Price is not valid");
//     }
//   }, [
//     minorCardShipping,
//     mediumCardShipping,
//     bigCardShipping,
//     price,
//     selectedPreference,
//   ]);


//   const handlePriceChange = (event) => {
//     const newPrice = event.trim(); // Remove leading/trailing spaces
//     let shipping = 0;
//     if (newPrice === "" || isNaN(newPrice) || parseFloat(newPrice) < 0) {
//       // If the input is empty, not a number, or less than 0, set the price state to an empty string and shipping to 0
//       setPrice("");
//       setShipping(0);
//     } else {
//       // Convert the input to a number and calculate shipping based on the price
//       const parsedPrice = parseFloat(newPrice);
//       setPrice(parsedPrice);
  
      
  
//       if (parsedPrice <= 20) {
//         shipping = minorCardShipping;
//       } else if (parsedPrice > 20 && parsedPrice <= 75) {
//         shipping = mediumCardShipping;
//       } else if (parsedPrice > 75) {
//         shipping = bigCardShipping;
//       }
  
//       setShipping(shipping);
//     }
  
//     console.log('selectedPreference',selectedPreference)
//     onPriceAndShippingChange(price, selectedPreference[0].value, shipping, acceptOffer);
//   };
  
 
//   const handleShippingTemplateChange = (event) => {
//     const newShippingTemplate = event.target.value;
//     setShippingTemplateId(newShippingTemplate);
//     // Update the selected preference
//     const currentPreference = shippingPreferences.find(
//       (preference) =>
//         parseInt(preference.value) === parseInt(newShippingTemplate)
//     );
//     setSelectedPreference(currentPreference);
//     setOtherDetails(currentPreference.otherDetails);

//     // Call the callback function to update the main form's formData
//     let shipping = 0;

//     if (!isNaN(price)) {
//       if (price <= 20) {
//         shipping = minorCardShipping;
//       } else if (price > 20 && price <= 75) {
//         shipping = mediumCardShipping;
//       } else if (price > 75) {
//         shipping = bigCardShipping;
//       }
//       setShipping(shipping);

//       onPriceAndShippingChange(
//         price,
//         currentPreference.value,
//         shipping,
//         acceptOffer
//       );
//     } else {
//       // Handle invalid input or provide user feedback
//       console.log("Error, Price is not valid");
//     }
//   };

 

//   const handleToggleOtherDetails = () => {
//     setShowOtherDetails(!showOtherDetails); // Toggle the visibility of "Other Details" input.
//   };
//   const handleAcceptOfferChange = (event) => {
//     const bestOffer = !acceptOffer;
//     setAcceptOffer(bestOffer);
//     onPriceAndShippingChange(
//       price,
//       selectedPreference.value,
//       shippingCost,
//       bestOffer
//     );
//   };

//   // Function to enter edit mode
//   const handleEdit = () => {
    
//     setEditedTitle(selectedPreference.label); // Set edited title
   
//     setEditedMinorCardShipping(minorCardShipping)
//     setEditedMediumCardShipping(mediumCardShipping)
//     setEditedBigCardShipping(bigCardShipping)
//     setEditedOtherDetails(otherDetails)
//     setEditedAdditionnalCard(AdditionnalCard)
//     setEditedShippingToCanada(ShippingToCanada)
//     setEditedShippingToUs(ShippingToUs)
//     setEditedShippingCostToUs(ShippingCostToUs)    
//     setEditing(true); // Enter editing mode
//   };

//   const handleCancel = () =>{
//     setEditing(false);
//     setEditedMinorCardShipping("")
//     setEditedMediumCardShipping("")
//     setEditedBigCardShipping("")
//     setEditedOtherDetails("")
//     setEditedAdditionnalCard("")
//     setEditedShippingToCanada(true)
//     setEditedShippingToUs(false)
//     setEditedShippingCostToUs("")  
//   }
// // Function to save the edited title
// const handleSave = () => {
//   // Update the title in your selected preference

//   if (editedTitle === "" && editedMinorCardShipping <= 0 && editedMediumCardShipping <= 0 && editedBigCardShipping <= 0) {
//     console.log('This is not okay. Check the red fields.');
//     return; // Don't proceed with the update if there are validation issues.
//   }
  
//  else if (editing) {
//   const  updatedPreference = {
//       TemplateTitle: editedTitle,
//       MinorCardShipping: editedMinorCardShipping,
//       MediumCardShipping: editedMediumCardShipping,
//       BigCardShipping: editedBigCardShipping,
//       OtherDetails: editedOtherDetails,
      
//      // acceptOffer: editedacceptOffer,
//       AdditionnalCard:editedAdditionnalCard,
//       ShippingToCanada:editedShippingToCanada,
//       ShippingToUs:editedShippingToUs,
//       ShippingCostToUs:editedShippingCostToUs,
//     };

//     console.log('ca que tu envoies',updatedPreference )
// // Now, you can send an API request to update the shipping preference

// Axios.put(`${process.env.REACT_APP_API_BASE}/api/update/shipping-preferences/${selectedPreference.value}`, {
//   userId,
//   updatedData: updatedPreference,
// },{ withCredentials: true })
//   .then((response) => {
//     // Handle success
//     const updatedItem = response.data;
//     // Do something with the updated item, if needed
//     console.log('ici le return data ',updatedItem)
//     getPreferences();
//   })
//   .catch((error) => {
//     // Handle error
//     console.error('Error updating shipping preference:', error);
//     // You can show an error message or handle the error in your UI
//   });


//     setEditing(false);
//   }

  


  
// };

// const getInputClassName = () => {
//   if (price === "" || parseFloat(price) === 0) {
//     return "red-input";
//   }
//   return "";
// };

//   return (
//     // <div>
//     //   <div className="flex-h">
//     //     Price (CAD) $
//     //     <input 
//     //       type="text"
//     //       value={price}
//     //       style={{ width: "15%",height:'25px'}}
//     //       onChange={handlePriceChange}
//     //       className={getInputClassName()}
          
//     //     />
//     //     Offer
//     //     <input
//     //       type="checkbox"
//     //       checked={acceptOffer}
//     //       onChange={handleAcceptOfferChange}
//     //       style={{height:'25px'}}
//     //     />
//     //   </div>
//     //   <div>
//     //     <h5>Shipped (+ ${shippingCost})</h5>{" "}
//     //   </div>

//     <div>
//     <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//       <thead>
//         <tr>
//           <th style={{ textAlign: 'left', padding: '8px' }}>Price ($)</th>
//           <th style={{ textAlign: 'center', padding: '8px' }}>Ship</th>
//           <th style={{ textAlign: 'center', padding: '8px' }}>Offer Accepted</th>
//         </tr>
//       </thead>
//       <tbody>
//         {/* Row #1: Price input, Ship input (disabled), Offer Accepted checkbox */}
//         <tr>
//           <td style={{ padding: '8px', textAlign: 'left' }}>
//             <input
//               id="priceInput"
//               type="text"
//               value={price}
//               maxLength={6}
//               style={{ width: "80%", textAlign: "right", padding: "5px" }} // Price input
//               onChange={(e) => handlePriceChange(e.target.value)} // Update price state
//               className={getInputClassName()} // Dynamic input class name if needed
//             />
//           </td>
//           <td style={{ padding: '8px', textAlign: 'center' }}>
//             <input
//               type="text"
//               value={shippingCost}
//               disabled
//               style={{
//                 width: "80%",
//                 textAlign: "center",
//                 backgroundColor: "lightgrey",
//                 color: "black",
//                 fontWeight: "bold",
//                 padding: "5px"
//               }} // Disabled shipping input
//             />
//           </td>
//           <td style={{ padding: '8px', textAlign: 'center' }}>
//             <input
//               type="checkbox"
//               checked={acceptOffer}
//               onChange={(e) => handleAcceptOfferChange(e.target.checked)} // Update accept offer state
//             />
//           </td>
//         </tr>
  
//         {/* Row #2: Total */}
//         <tr>
//           <td colSpan="3" style={{ padding: '8px', textAlign: 'right' }}>
//             <h5 style={{ margin: 0 }}>Total: ${(parseFloat(price) + parseFloat(shippingCost)).toFixed(2)}</h5>
//           </td>
//         </tr>
//       </tbody>
//     </table>
//   </div>
  




// //       {/* <div>
// //         <div style={{ border: "1px solid #ccc", padding: "10px" }}>
// //           <div
// //             style={{
// //               display: "flex",
// //               justifyContent: "center",
// //               alignItems: "center",
// //               textAlign: "center",
// //             }}
// //           >
// //             <h3 style={{ fontWeight: "bold" }}> Shipping Template </h3>
// //           </div>
// //           <div
// //             style={{
// //               display: "flex",
// //               justifyContent: "center",
// //               alignItems: "center",
// //               textAlign: "center",
// //             }}
// //           >
// //        {!editing ? (
// //             <select
// //               value={shippingTemplateId}
// //               onChange={handleShippingTemplateChange}
// //               className="custom-select"
// //             >
// //               {shippingPreferences.map((preference) => (
// //                 <option key={preference.value} value={preference.value}>
// //                   {preference.label}
// //                 </option>
// //               ))}
// //             </select>
// //        ):(<input style={{width:'60%'}}value={editedTitle} onChange={(e) => setEditedTitle(e.target.value)} />)}
// //             {!editing ? (
// //   <button onClick={handleEdit}>View/Edit</button>
// // ) : (
// //   <>
// //     <button style={{width:'20%',height:'15%', border: "1px solid #ccc"}}onClick={handleSave}>Save</button>
// //     <button style={{width:'20%',height:'15%', border: "1px solid #ccc"}}onClick={handleCancel}>Cancel</button>
// //   </>
// //     )}</div>


// //     {editing?(<> 
// //   <h4>Cost($) </h4>
// //         <div
// //           style={{
// //             display: "flex",
// //             flexDirection: "row",
// //             justifyContent: "space-around",
// //           }}
// //         >
       
// //           <div>
// //             <h6>(under $20)</h6>
// //             <input
// //               type="text"
// //               value={editing?editedMinorCardShipping:minorCardShipping}
// //               disabled={!editing}
// //               onChange={(e) => setEditedMinorCardShipping(e.target.value)}
// //               style={{ width: "3em",
// //               backgroundColor:
// //               (editing?editedMinorCardShipping:minorCardShipping) <= 0
// //                 ? "red"
// //                 : "", // Change to red if value is empty or <= 0 
// //             }}
// //             />
// //           </div>
// //           <div>
// //             <h6>(under $75)</h6>
// //             <input
// //               type="text"
// //               value={editing?editedMediumCardShipping:mediumCardShipping}
// //               disabled={!editing}
// //               onChange={(e) => setEditedMediumCardShipping(e.target.value)}
// //               style={{ width: "3em",
// //               backgroundColor:
// //               (editing ? editedMediumCardShipping : mediumCardShipping) <= 0
// //                 ? "red"
// //                 : "", // Change to red if value is empty or <= 0 
// //             }}
// //             />
// //           </div>
// //           <div>
// //             <h6>(above $75)</h6>
// //             <input
// //               type="text"
// //               value={editing?editedBigCardShipping:bigCardShipping}
// //               disabled={!editing}
// //               onChange={(e) => setEditedBigCardShipping(e.target.value)}
// //               style={{ width: "3em",
// //               backgroundColor:
// //               (editing?editedBigCardShipping:bigCardShipping) <= 0
// //                 ? "red"
// //                 : "", // Change to red if value is empty or <= 0 
// //             }}
// //             />
// //           </div>
// //         </div>
        

// //         <div className='flex-h' style={{marginTop:'1vh'}}>
// //               <label htmlFor="ShippingCanada">Ship (in/to) Canada</label>
// //               <input type='checkbox'
              
// //                 checked={editedShippingToCanada}
// //                 onChange={(e) => setEditedShippingToCanada(e.target.checked)}
// //               />
// //               </div>
// //               <div className='flex-h' style={{marginTop:'1vh',marginBottom:'1vh'}} >
// //               <label htmlFor="ShippingUS" >Ship (in/to) USA</label>
// //               <input type='checkbox'
// //               style={{marginLeft:'2vw'}}
// //                 checked={editedShippingToUs}
// //                 onChange={(e) => setEditedShippingToUs(e.target.checked)}
// //                 value={editing?editedShippingToUs:ShippingToUs}
// //               />
// //               </div>
// //               {editedShippingToUs && (
// //                 <>
                 
// //                   <div style={{marginRight:'10px'}}>
// //         <label htmlFor={ShippingCostToUs}>{'Shipping Cost to USA'}</label>
// //         <div style={{width:'5vw'}}>
// //           <input
// //             type="text"
// //             id={ShippingCostToUs}
// //             value={editing?editedShippingCostToUs:ShippingCostToUs}             // Dynamically access state based on fieldName
// //             onChange={e => setEditedShippingCostToUs(e.target.value)}
// //             style={{ 
// //               backgroundColor:
// //               (editing?editedShippingCostToUs:ShippingCostToUs) <= 0
// //                 ? "red"
// //                 : "",}}
// //             maxLength={6}
// //             onInput={e => {
// //               e.target.value = e.target.value.replace(/[^0-9.]/g, ''); // Allow numbers and decimal points
// //             }}
// //           />
// //         </div>
// //       </div>



// //                 </>
// //               )}

// //         <div>
// //           {!showOtherDetails && (
// //             <button onClick={handleToggleOtherDetails}>
// //               Toggle Other Details
// //             </button>
// //           )}
// //           {showOtherDetails && (
// //             <div>
// //               <label htmlFor="otherDetails">Other Details</label>
// //               <textarea
// //                 id="otherDetails"
// //                 value={editing?editedOtherDetails:otherDetails}
// //                 onChange={(e) =>setEditedOtherDetails(e.target.value)}
// //                 disabled={!editing}
// //                 rows="5" // Number of rows (adjust as needed)
// //                 cols="26" // Number of columns (adjust as needed)
// //               />
// //             </div>
// //           )}
// //            </div>
// //            </>):(<></>)}
// //         </div>
          
// //       </div> */}
      
    
//   );
// }

// export default ForSalePriceAndTemplate;


// function ForSalePriceAndTemplate({
//   initialBestOffer,
//   initialPrice,
//   onPriceAndShippingChange,
//   tabIndex,
//   t
// }) {
//   const { userId } = useContext(AuthContext);
//   const [price, setPrice] = useState(initialPrice);
//   const [selectedPreference, setSelectedPreference] = useState(null);
//   const [shippingCost, setShippingCost] = useState("");
//   const [acceptOffer, setAcceptOffer] = useState(initialBestOffer);

//   function getPreferences() {
//     fetch(`${process.env.REACT_APP_API_BASE}/api/get/shipping-preferences/${userId}`, {
//     method: 'GET',
//     credentials: 'include',
//   })
//       .then((response) => response.json())
//       .then((data) => {
//         const preference = {
//           label: data.TemplateTitle,
//           value: data.ShippingPreferenceId,
//           minorCardShipping: data.MinorCardShipping,
//           mediumCardShipping: data.MediumCardShipping,
//           bigCardShipping: data.BigCardShipping,
//           otherDetails: data.OtherDetails,
//           acceptOffer: data.acceptOffer,
//         };
//         console.log('data',data)
//         setSelectedPreference(preference);
//       })
//       .catch((error) => {
//         console.log("Error:", error);
//       });
//   }

//   useEffect(() => {
//     getPreferences();
//   }, []);

//   useEffect(() => {
//     if (selectedPreference && !isNaN(price)) {
//       let shipping = 0;
//       if (price <= 25) {
//         shipping = selectedPreference.minorCardShipping;
//       } else if (price <= 75) {
//         shipping = selectedPreference.mediumCardShipping;
//       } else {
//         shipping = selectedPreference.bigCardShipping;
//       }
//       setShippingCost(shipping);
//     }
//   }, [price, selectedPreference]);

//   const handlePriceChange = (e) => {
//     let newPrice = e.trim();
  
//     if (newPrice === "" || isNaN(newPrice) || parseFloat(newPrice) < 0) {
//       setPrice(0);
//       onPriceAndShippingChange(0, selectedPreference.value, shippingCost, acceptOffer);
//       return;
//     }
  
//     setPrice(parseFloat(newPrice));
//     onPriceAndShippingChange(parseFloat(newPrice), selectedPreference.value, shippingCost, acceptOffer);
//   };

//   const handleAcceptOfferChange = (e) => {
//     setAcceptOffer(e.target.checked);
//     onPriceAndShippingChange(price, selectedPreference.value, shippingCost, e.target.checked);
//   };

//   return (
//     <div>
//       <table style={{maxWidth:'66%'}} >
//         <thead>
//           <tr>
//             <th>{t('Price')} ($)</th>
//             <th>{t('Ship')}</th>
//             <th>{t('Offer')}</th>
//           </tr>
//         </thead>
//         <tbody>
//           <tr>
//             <td>
//               <input
//                 type="text"
//                 value={price}
//                 maxLength={6}
//                 onChange={(e) => handlePriceChange(e.target.value)}
//                 style={{  textAlign: "center", minWidth:'8vw' }}
//                 tabIndex={tabIndex}
//                 onFocus={(e) => e.target.select()}
//               />
//             </td>
//             <td>
//               <input
//                 type="text"
//                 value={shippingCost}
//                 disabled
//                 style={{ backgroundColor: "lightgrey", textAlign: "center", fontWeight: "bold",minWidth:'5vw'}}
                
//               />
//             </td>
//             <td>
//               <input type="checkbox" checked={acceptOffer} onChange={handleAcceptOfferChange} tabIndex={tabIndex+1} />
//             </td>
//           </tr>

//         </tbody>
//       </table>
//     </div>
//   );
// }
// export default ForSalePriceAndTemplate;

import React, { useContext, useEffect, useMemo, useState,useRef } from "react";
import { UserContext } from "../login/LoginForm";
import { AuthContext } from "../login/AuthContext";
import Axios from 'axios';
import "./ForSalePriceAndTemplate.css"



function ForSalePriceAndTemplate({
  initialBestOffer = false,
  initialPrice = "",
  onPriceAndShippingChange,
  tabIndex = 0,
  t,
}) {
  const { userId } = useContext(AuthContext);

  const [price, setPrice] = useState(
    typeof initialPrice === "number" ? initialPrice.toFixed(2) : `${initialPrice || ""}`
  );
  const [pref, setPref] = useState(null);
  const [loading, setLoading] = useState(true);
  const [acceptOffer, setAcceptOffer] = useState(!!initialBestOffer);
  const [error, setError] = useState("");

  // fetch shipping template
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE}/api/get/shipping-preferences/${userId}`,
          { method: "GET", credentials: "include" }
        );
        const d = await res.json();
        setPref({
          label: d.TemplateTitle,
          value: d.ShippingPreferenceId,
          minorCardShipping: d.MinorCardShipping,
          mediumCardShipping: d.MediumCardShipping,
          bigCardShipping: d.BigCardShipping,
          otherDetails: d.OtherDetails,
          acceptOffer: d.acceptOffer,
        });
      } catch (e) {
        console.error("Shipping preferences error:", e);
      } finally {
        setLoading(false);
      }
    })();
  }, [userId]);

  // compute ship based on price
  const shippingCost = useMemo(() => {
    const p = parseFloat(String(price).replace(",", "."));
    if (!pref || !Number.isFinite(p)) return 0;
    if (p <= 25) return pref.minorCardShipping ?? 0;
    if (p <= 75) return pref.mediumCardShipping ?? 0;
    return pref.bigCardShipping ?? 0;
  }, [price, pref]);

  // notify parent whenever anything meaningful changes
const cbRef = useRef(onPriceAndShippingChange);
useEffect(() => { cbRef.current = onPriceAndShippingChange; }, [onPriceAndShippingChange]);

const lastSent = useRef(null);
useEffect(() => {
  const p = parseFloat(String(price).replace(",", "."));
  const payload = {
    price: Number.isFinite(p) ? p : 0,
    prefId: pref?.value ?? null,
    ship: shippingCost ?? 0,
    offer: acceptOffer,
  };
  if (JSON.stringify(payload) !== JSON.stringify(lastSent.current)) {
    lastSent.current = payload;
    cbRef.current?.(payload.price, payload.prefId, payload.ship, payload.offer);
  }
}, [price, pref, shippingCost, acceptOffer]);
  // useEffect(() => {
  //   if (!onPriceAndShippingChange) return;
  //   const p = parseFloat(String(price).replace(",", "."));
  //   onPriceAndShippingChange(
  //     Number.isFinite(p) ? p : 0,
  //     pref?.value ?? null,
  //     shippingCost ?? 0,
  //     acceptOffer
  //   );
  // }, [price, pref, shippingCost, acceptOffer, onPriceAndShippingChange]);

  // pretty printer
  const nf = useMemo(
    () => new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    []
  );

  // only digits + one decimal separator, capped at 2 decimals
  const onPriceInput = (e) => {
    setError("");
    let v = e.target.value
      .replace(/[^\d.,]/g, "")   // keep digits and separators
      .replace(",", ".");        // normalize to .
    const [int = "", dec = ""] = v.split(".");
    const dec2 = dec.slice(0, 2);
    v = dec.length ? `${int}.${dec2}` : int;
    if (v.length > 8) v = v.slice(0, 8);
    setPrice(v);
  };

  const onPriceBlur = () => {
    if (price === "") return setPrice("");
    const n = parseFloat(price);
    if (!Number.isFinite(n)) {
      setError(t?.("Enter a valid price") || "Enter a valid price");
      setPrice("");
      return;
    }
    setPrice(n.toFixed(2));
  };

  return (
    <div className="fs-panel">
      {/* Price */}
      <div className="fs-field">
        <label className="fs-label">{t?.("Price") || "Price"} ($)</label>
        <div className={`fs-input-wrap ${error ? "is-invalid" : ""}`}>
          
          <input
            className="fs-input"
            inputMode="decimal"
            placeholder="0.00"
            value={price}
            onChange={onPriceInput}
            onBlur={onPriceBlur}
            tabIndex={tabIndex}
            style={{padding:'10px'}}
          />
        </div>
        {error && <div className="fs-error">{error}</div>}
      </div>

      {/* Ship */}
      <div className="fs-field">
        <label className="fs-label">{t?.("Ship") || "Ship"}</label>
        <div className="fs-badge" aria-live="polite">
          {loading ? "—" : `$${nf.format(shippingCost || 0)}`}
        </div>
        {/* {!!pref?.label && <div className="fs-help">{pref.label}</div>} */}
      </div>

      {/* Offer */}
      <div className="fs-field">
        <label className="fs-label">{t?.("Offer") || "Offer"}</label>
        <label className="fs-switch">
          <input
            type="checkbox"
            checked={acceptOffer}
            onChange={(e) => setAcceptOffer(e.target.checked)}
            tabIndex={tabIndex + 1}
          />
          <span className="fs-slider" />
        </label>
      </div>
    </div>
  );
}

export default ForSalePriceAndTemplate;
